import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BsFillTriangleFill from '@/components/UI/svg/Icons/BsFillTriangleFill';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Section1() {
    const { useState, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('delta_max_static');
    const { locale } = useRouter();
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/uyB6HaquXvo',
        cn: {
            SD: 'https://videos.ecoflow.com/62db14750ce449a8a90b8e0a51385827/5530f493decb434cacbcc7a7e95e28bc-d7aa9a629894d1edaa7bb7930a3cd1db-fd.mp4',
            HD: 'https://videos.ecoflow.com/62db14750ce449a8a90b8e0a51385827/5530f493decb434cacbcc7a7e95e28bc-253b03881f702b615d0ffc2c7cc97e92-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/23eca575-182edca7b98-0004-9c91-e6d-40030.mp4',
        },
    };

    return (
        <>
            <div className={`${css.section01} animation`}>
                <div className="video-wrapper">
                    <EFVideo sources={['/video/deltamax/kv2.webm', '/video/deltamax/kv2.mp4']} loop={false} />
                </div>
                <div className="text-wrapper">
                    <div className="title font-family-semibolder">{t('banner_title_h5')}</div>
                    <div className="desc font-family-extrabold">{t('bannner_desc_h5')}</div>
                    <button
                        onClick={() => {
                            setShowEFVideoModal(true);
                            gtm?.push({
                                event: 'uaEvent',
                                event_name: 'video',
                                title_name: 'DELTA Max',
                                position: 'Product Detail_1',
                            });
                        }}
                        className="watch-video font-family-medium"
                    >
                        {t('watch_video')}
                        <BsFillTriangleFill className="arrow-triangle-right" />
                    </button>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </>
    );
}
